import React, { useState, useEffect } from "react";
import Navapp from "../nav-app/Navapp";
import { Routes, Route } from "react-router-dom";
import { Container } from "react-bootstrap";
import { MainDashboard } from "../../dashboards";
import { MainProducts } from "../../products";
import { MainHome } from "../../home";
import { MainSizeGuides } from "../../sizes-guides";
import "./ContentApp.css";
import { useLanguage } from "../../../../contexts/LanguageContext";
import { MercadoShops } from "../../mercadoshops";
import { TiendaNube } from "../../tiendanube";
import { CrispChat } from "../../common";
import { Tools } from "../../tools";
import { StorageServices } from "../../../services";
import { Tools as ToolService } from "../../../misc";

const ContentApp: React.FC = () => {
  const { readysizelocale } = useLanguage();
  const [user, setUser] = useState(StorageServices.GetCookieUser());
  const [isMenuColapse, setIsMenuColapse] = useState(true);

  useEffect(() => {
    if (ToolService.IsDevelopment()) console.log("STATE CONTENT-APP", user);
  }, [user]);

  const onEventMenuWidthChange = (menuState: boolean) => {
    setIsMenuColapse(menuState);
  };

  return (
    <>
      <Navapp onClickMenuAside={onEventMenuWidthChange} />
      <Container fluid>
        <div
          style={{
            marginTop: "65px",
            marginLeft: isMenuColapse ? "50px" : "176px",
          }}
        >
          <div className="main-content-fitprenda">
            {user.Contract.Id !== 1 && <CrispChat />}
            <Routes>
              <Route
                path="/"
                element={<MainHome selectedLanguage={readysizelocale} />}
              />
              <Route path="/charts/*" element={<MainDashboard />} />
              <Route path="/categories/*" element={<></>} />
              <Route path="/products/*" element={<MainProducts />} />
              <Route
                path="/sizes-guides/*"
                element={<MainSizeGuides selectedLanguage={readysizelocale} />}
              />
              <Route path="/tools/*" element={<Tools />} />
              <Route path="/mercado-shops/*" element={<MercadoShops />} />
              <Route path="/tienda-nube/*" element={<TiendaNube />} />
            </Routes>
          </div>
        </div>
      </Container>
    </>
  );
};

export default ContentApp;
